import { UnionMap } from '../types/union-map';

export type BooleanString = 'true' | 'false';
export const BooleanString: UnionMap<BooleanString> = { true: 'true', false: 'false' };
